import DcddUserInfo from "./components/DcddUserInfo";
import { useLocation, useParams } from "react-router-dom";
import { DcddUserProps, RegisteredDcddUserProps } from "../state/actionType";

const DcddSingleUserProfile: React.FC = () => {
  const { userId } = useParams<{ userId: string }>();
  const location = useLocation();
  const userData = location.state?.userData as DcddUserProps;
  const getUserData = userData;
  const getUserProfileData = userData.user_profile;

  return (
    <div className="p-8 h-full overflow-hidden">
      <h2 className="text-2xl font-bold mb-2">DCDD User Deatils</h2>
      <div className="border my-6 " />
      <div className="overflow-auto max-h-[74vh] scrollbar-hide">
        <DcddUserInfo dcddData={userData} user={getUserData} profile={getUserProfileData} />
      </div>
    </div>
  );
};

export default DcddSingleUserProfile;
